var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7812 0.625H3.21875C1.92641 0.625 0.875 1.67641 0.875 2.96875V16.5625C0.875 17.8548 1.92641 18.9062 3.21875 18.9062H24.7812C26.0736 18.9062 27.125 17.8548 27.125 16.5625V2.96875C27.125 1.67641 26.0736 0.625 24.7812 0.625Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7812 2.03125H3.21875C2.70312 2.03125 2.28125 2.45312 2.28125 2.96875V4.375H25.7188V2.96875C25.7188 2.45312 25.2969 2.03125 24.7812 2.03125Z",
    fill: "#AAB2BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7812 2.96875H3.21875C2.70312 2.96875 2.28125 3.39062 2.28125 3.90625V4.4043H25.7188V3.90625C25.7188 3.39062 25.2969 2.96875 24.7812 2.96875Z",
    fill: "#F2FAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7188 16.5625C25.7188 17.0781 25.2969 17.5 24.7812 17.5H3.21875C2.70312 17.5 2.28125 17.0781 2.28125 16.5625V4.375C2.28125 3.85938 2.70312 3.4375 3.21875 3.4375H24.7812C25.2969 3.4375 25.7188 3.85938 25.7188 4.375V16.5625Z",
    fill: "#D8E0EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8125 15.1562C19.4013 15.1562 21.5 13.0576 21.5 10.4688C21.5 7.87992 19.4013 5.78125 16.8125 5.78125C14.2237 5.78125 12.125 7.87992 12.125 10.4688C12.125 13.0576 14.2237 15.1562 16.8125 15.1562Z",
    fill: "#FFA914"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 10.4688C12.125 10.3284 12.1313 10.1894 12.1434 10.0521H15.8555C15.8307 9.77032 15.7804 9.49138 15.7052 9.21871H12.2936C12.3731 8.93136 12.4801 8.6523 12.6129 8.38539H15.3866C15.2395 8.08967 15.0615 7.81034 14.8556 7.55207H13.1429C13.3921 7.23904 13.6801 6.959 14 6.71869C13.2165 6.13018 12.2428 5.78125 11.1875 5.78125C8.59865 5.78125 6.5 7.8799 6.5 10.4688C6.5 13.0577 8.59865 15.1562 11.1875 15.1562C12.2428 15.1562 13.2165 14.8073 14 14.2188C13.6801 13.9785 13.3921 13.6984 13.1429 13.3854H14.8556C15.0615 13.1271 15.2395 12.8477 15.3866 12.552H12.6129C12.4801 12.2851 12.3731 12.006 12.2936 11.7187H15.7052C15.7805 11.446 15.8308 11.167 15.8555 10.8852H12.1434C12.1311 10.7467 12.125 10.6078 12.125 10.4688Z",
    fill: "#EF4136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardlogo);
export default __webpack_public_path__ + "static/media/cardlogo.5fba236569346446c081e079134645a7.svg";
export { ForwardRef as ReactComponent };